var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83053_72761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83053_72761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08979 17.0841C5.66882 17.0841 5.3125 16.9383 5.02083 16.6466C4.72917 16.3549 4.58333 15.9986 4.58333 15.5776V5.00076H3.75V3.75076H7.5V3.01367H12.5V3.75076H16.25V5.00076H15.4167V15.5776C15.4167 15.9986 15.2708 16.3549 14.9792 16.6466C14.6875 16.9383 14.3312 17.0841 13.9102 17.0841H6.08979ZM7.83667 14.1674H9.08646V6.66742H7.83667V14.1674ZM10.9135 14.1674H12.1633V6.66742H10.9135V14.1674Z",
    fill: "#B3261D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f66b8c00c8d1d4fede579f441def4fec.svg";
export { ForwardRef as ReactComponent };